import { EXPRESSCHAR } from "@/constants/members";

const getNumber = (fullNumber, final = false) => {
  let sum = 0;
  let numberStr = String(fullNumber);

  for (let i = 0; i < numberStr.length; i++) {
    sum = sum + Number(numberStr.charAt(i));
  }

  if (sum === 10) return 1;
  if (!final && sum >= 10 && sum !== 11 && sum !== 22) {
    sum = getNumber(sum, final);
  }

  return sum;
};

export const calculateLifepath = ({ year, month, day }) => {
  const yearNum = getNumber(year);
  const monthNum = getNumber(month);
  const dayNum = getNumber(day);

  let sum = yearNum + monthNum + dayNum;
  if (sum === 10) return 1;
  if (sum > 10 && sum !== 11 && sum !== 22) {
    sum = getNumber(yearNum + monthNum + dayNum, true);
  }
  // console.log("client info: ", clientData, sum);
  return sum;
};

export const calculateExpressionNumber = ({ firstNames, lastName }) => {
  let nameArray = [];
  let numberSum = 0;

  let tmp = firstNames.split(" ");
  nameArray = nameArray.concat(tmp);

  tmp = lastName.split(" ");
  nameArray = nameArray.concat(tmp);

  for (let i = 0; i < nameArray.length; i++) {
    let sum = 0;
    for (let j = 0; j < nameArray[i].length; j++) {
      sum = sum + EXPRESSCHAR.findIndex((item) => item.indexOf(nameArray[i].charAt(j).toUpperCase()) >= 0) + 1;
    }

    numberSum = numberSum + getNumber(sum);
  }

  return getNumber(numberSum);
};

export const calculateIMC = ({ weight, height }) => {
  const result = weight / (height * height);
  return +result.toFixed(2);
};
